<div class="fullcontainer">
  <div class="sheet">
    <h1 class='header'>Cancel Absence</h1>

    <p>Are you sure you wish to cancel this absence? This action cannot be undone</p>

    <button type="submit" class="btn btn-danger" (click)='this.onCancelClicked()'>Yes! I'm Sure!</button>&nbsp;
    <button type="button" class="btn btn-primary" routerLink='/drivers/absence'>No! Take me back!</button>
  </div>
</div>
